import { defineNuxtPlugin, useRuntimeConfig } from 'nuxt/app';
import { injectionNameClient, injectionNameGtm } from '../shared/injectionNames';
import { LOG_LEVEL, type AwLogLevel } from '../shared/logLevel';
import { LOG_LEVEL_HIERARCHY, isAwLogLevel } from '../shared/loggingTypes';
import type { AwLoggerClient, LogMethod } from '../shared/loggingTypes';

function createPluginProvides () {

  const generateLogger = ({
    selectedLogLevel,
    categoryName,
  }: {
    selectedLogLevel: AwLogLevel;
    categoryName: string;
  }): AwLoggerClient => {
    if (!selectedLogLevel) {
      /* eslint-disable-next-line no-console */
      console.error(`selectedLogLevel is incorrect for categoryName ${categoryName}:`, selectedLogLevel);
    }

    function getLoggerForLogLevel (ll: AwLogLevel) {
      let fun: LogMethod;
      const isLogDisabled = LOG_LEVEL_HIERARCHY[ll] < LOG_LEVEL_HIERARCHY[selectedLogLevel];
      if (isLogDisabled) {
        fun = () => {};
      } else {
        if (ll === 'fatal') {
          // eslint-disable-next-line no-console
          fun = console.error;
        } else {
          // eslint-disable-next-line no-console
          fun = console[ll];
        }
        fun = fun.bind(console, categoryName);
      }
      return fun;
    }

    return {
      [LOG_LEVEL.TRACE]: getLoggerForLogLevel(LOG_LEVEL.TRACE),
      [LOG_LEVEL.DEBUG]: getLoggerForLogLevel(LOG_LEVEL.DEBUG),
      [LOG_LEVEL.INFO]: getLoggerForLogLevel(LOG_LEVEL.INFO),
      [LOG_LEVEL.WARN]: getLoggerForLogLevel(LOG_LEVEL.WARN),
      [LOG_LEVEL.ERROR]: getLoggerForLogLevel(LOG_LEVEL.ERROR),
      [LOG_LEVEL.FATAL]: getLoggerForLogLevel(LOG_LEVEL.FATAL),
    } satisfies Record<AwLogLevel, LogMethod>;
  };

  const {
    logLevelGtm,
  } = useRuntimeConfig().public;

  const loggers = {
    [injectionNameClient]: generateLogger({
      selectedLogLevel: LOG_LEVEL.TRACE,
      categoryName: 'aw -',
    }),
    [injectionNameGtm]: generateLogger({
      selectedLogLevel: isAwLogLevel(logLevelGtm) ? logLevelGtm : LOG_LEVEL.ERROR,
      categoryName: 'awGtm -',
    }),
  };

  return loggers;
}

export type LoggingClientPluginProvides = ReturnType<typeof createPluginProvides>;

export default defineNuxtPlugin(() => {
  return {
    provide: createPluginProvides(),
  };
});
